import React from 'react';
import { Box, Flex, Image, Text, Link } from '@chakra-ui/react';

const Footer = () => {
  return (
    <Box as="footer" bg="teal.700" color="white" textAlign="center">
      <Flex justify="center" align="center" wrap="wrap" gap={{ base: 6, md: 12 }} bg="white" px={6} py={6} borderTop="1px" borderColor="gray.200">
        <Link href="https://www.um.edu.my/" aria-label="Universiti Malaya">
          <Image src={`${process.env.PUBLIC_URL}/brand/universiti-malaya.png`} alt="Universiti Malaya" w="200px" h="72px" objectFit="contain" loading="lazy" />
        </Link>
        <Link href="https://www.smartcore.group/" aria-label="SmartCore Digital" bg="gray.900" px={4} borderRadius="md">
          <Image src={`${process.env.PUBLIC_URL}/brand/smartcore-digital.png`} alt="SmartCore Digital" w="220px" h="72px" objectFit="contain" loading="lazy" />
        </Link>
      </Flex>
      <Box py={4} px={6}>
        <Text>
          CQR Quranic AI Datahub © {new Date().getFullYear()}
        </Text>
        <Text fontSize="sm" mt={2}>
          A tool for exploring and studying the Holy Quran
        </Text>
      </Box>
    </Box>
  );
};

export default Footer;
